
<div *ngIf="isLoadingResults" class="wrapperLoader">
    <div class="loader">
    </div>
</div>
<nav aria-label="breadcrumb" class="bg-none sticky-top">
    <ol class="breadcrumb bg-white border-bottom pl-4 mb-0">
        <div class="col-xs-12 col-md-6 d-flex flex-wrap">
            <span class="w-100">Shipment Management</span>
            <li class="breadcrumb-item"><a href="/dashboard">Home</a></li>
            <li class="breadcrumb-item active" aria-current="page">Shipment Management</li>
        </div>
        <ng-container *ngIf="authorization.hasPrivilege('shipment-add')">
            <div *ngIf="!isFranchiseeLogin" class="col-xs-12 col-md-6">
                <div class="d-flex" style="justify-content: flex-end;">
                    <a [routerLink]="['/consolidation-shipments/add']" class="btn package-btn mt-md-2 mt-0">
                        <img src="assets/images/add.png" class="pb-1 pr-1">
                        Add Shipment</a>
                </div>
            </div>
        </ng-container>

        <div *ngIf="authorization.hasPrivilege('scannewshipment') && isFranchiseeLogin" class="col-xs-12 col-md-6">
            <div class="d-flex" style="justify-content: flex-end;">
                <a [routerLink]="['/scan-shipment']" class="btn package-btn mt-md-2 mt-0">
                    <img src="assets/images/add.png" class="pb-1 pr-1">
                    Scan New Shipment</a>
            </div>
        </div>
    </ol>
</nav>
<div class="container-fluid">
    <div class="kg-data-table table-responsive">
        <div class="kg-form-data kg-data-2 position-relative mb-md-4 mb-2 mt-md-3 mt-2">
            <span class="position-absolute kg-tag">Search Shipment</span>

            <div class="form-row">
                <div *ngIf="!isFranchiseeLogin" class="form-group col-md-3">
                    <label class="label-txt" for="inputState">Franchisee</label>
                    <select floatinputModel id="inputState" class="form-control input" [(ngModel)]="franchiseeId">
                        <option value="" selected>Select</option>
                        <option *ngFor="let data of franchiseeList" value="{{data.franchiseId}}">
                            {{data.franchiseName}}
                        </option>
                    </select>
                    <span class="bar"></span>
                </div>
                <div class="form-group col-md-3">
                    <label class="label-txt" for="tnumber">Shipment ID</label>
                    <input floatinputModel type="text" class="form-control input" [(ngModel)]="shipmentId">
                    <span class="bar"></span>
                </div>
                <div class="form-group col-md-3">
                    <label class="label-txt" for="cid">Shipment Date</label>

                    <input floatinputModel type="text" class="form-control input" bsDatepicker
                        [(ngModel)]="shipmentDate" [bsConfig]="{ dateInputFormat: 'DD MMM YYYY' }">
                    <span class="bar"></span>


                </div>
                <div class="form-group col-md-3">
                    <label class="label-txt" for="status">Status</label>
                    <select floatinputModel class="form-control input" id="status" [(ngModel)]="status">
                        <option selected value="">Select</option>
                        <option *ngFor="let data of statusEnum" value="{{data.key}}">{{data.value}}
                        </option>
                    </select>
                    <span class="bar"></span>
                </div>
            </div>
            <div class="d-flex kg-cust-btn">
                <div class="d-flex" style="justify-content: flex-end;">
                    <button type="button" class="btn btn-info" (click)="search()">
                        <!-- <img src="images/add.png" class="pb-1 pr-1"> -->
                        Search
                    </button>
                </div>
                <div class="d-flex" style="justify-content: flex-end;">
                    <button type="button" class="btn btn-info" (click)="reset()">
                        <!-- <img src="images/add.png" class="pb-1 pr-1"> -->
                        Reset
                    </button>
                </div>
            </div>

        </div>
        <div>
            <div class="row">
                <div class="col-sm-12 col-md-2">
                    <div class="dataTables_length">
                        <label class="d-flex align-items-center mb-0 mt-md-1 mt-0">Show
                            <select style="margin: 0 5px;padding: 2px;" #pageSize
                                (change)='setPageSize(pageSize.value)'>
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                            entries</label>
                    </div>
                </div>
            </div>
            <table class="table mb-0 table-striped text-center">
                <thead>
                    <tr>
                        <th (click)="onSortClick($event)" *ngFor="let col of displayedColumns">{{col}}
                            <ng-container *ngIf="ApplyMapping(col) == sortby">
                                <i class="sorticon-color fa "
                                    [ngClass]="{'fa-sort-asc': order =='asc',  'fa-sort-desc': order== 'desc'}"></i>
                            </ng-container>
                            <ng-container *ngIf="ApplyMapping(col) != sortby">
                                <i class="fa fa-sort kg-gray"></i>
                            </ng-container>
                        </th>                        
                            <th *ngIf="!isFranchiseeLogin">
                                <ng-container *ngIf="authorization.hasPrivilege('shipment-edit') || authorization.hasPrivilege('shipment-delete')"> 
                                Action
                            </ng-container>
                            </th>                        
                    </tr>
                </thead>
                <tbody *ngIf="data.length > 0">
                    <tr *ngFor="let row of data">
                        <!-- <td>{{travel.dateCreated | date:'dd/MM/yy: HH:mm' }}</td> -->
                        <td *ngIf="!isFranchiseeLogin"><a
                                [routerLink]="['/consolidation-shipments/detail', row.shipmentId]">{{row.shipmentCode}}</a>
                        </td>
                        <td *ngIf="isFranchiseeLogin"><a
                                [routerLink]="['/scan-shipment', row.shipmentId]">{{row.shipmentCode}}</a></td>
                        <td>{{row.shipmentDate}}</td>
                        <td>{{row.country}}</td>
                        <td>{{row.noOfOverpacks}}</td>
                        <td>{{row.packagesCount}}</td>
                        <td>{{row.weight}} {{row.weightMeassure}}</td>
                        <td>{{row.status}}</td>
                        <ng-container *ngIf="authorization.hasPrivilege('shipment-edit')">
                            <td *ngIf="!isFranchiseeLogin">
                                <div class="dropdown kg-action-drop"
                                        *ngIf="authorization.hasPrivilege('shipment-edit') && !authorization.hasPrivilege('shipment-delete')">
                                        <a class="dropdown-toggle border-0" href="javascript:void(0)" 
                                            [routerLink]="['/consolidation-shipments/edit', row.shipmentId]">Edit</a>
                                    </div>
                                    <div class="dropdown kg-action-drop"
                                        *ngIf="authorization.hasPrivilege('shipment-delete') && !authorization.hasPrivilege('shipment-edit')">
                                        <a class="dropdown-toggle border-0" href="javascript:void(0)" *ngIf="row.statusInt == ShipmentStatusEnum.Unshipped"
                                            (click)="DeleteShipment(row.shipmentId)">Delete</a>
                                    </div>
                                <div class="dropdown kg-action-drop">
                                    <ng-container
                                    *ngIf="authorization.hasPrivilege('shipment-delete') && authorization.hasPrivilege('shipment-edit')">

                                    <button class="dropdown-toggle border-0" type="button" data-toggle="dropdown"
                                        aria-haspopup="true" aria-expanded="false">
                                        Edit <i class="fa fa-caret-down" aria-hidden="true"></i>
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <a class="dropdown-item" href="javascript:void(0)" 
                                            [routerLink]="['/consolidation-shipments/edit', row.shipmentId]">Edit</a>
                                        <a class="dropdown-item" href="javascript:void(0)" *ngIf="row.statusInt == ShipmentStatusEnum.Unshipped"
                                            (click)="DeleteShipment(row.shipmentId)">Delete</a>
                                    </div>
                                    </ng-container>
                                </div>
                            </td>
                        </ng-container>
                    </tr>
                </tbody>
                <tbody *ngIf="data.length === 0 && !isLoadingResults">
                    <tr>
                        <td colspan="8">
                            <div class="col-md-12 text-center text-info">
                                <h6>
                                    <span class="tim-note">No Records.</span>
                                </h6>
                            </div>
                        </td>
                    </tr>
                </tbody>

            </table>
            <div class="d-flex kg-pagination" *ngIf="data.length > 0">
                <div class="dataTables_info" role="status" aria-live="polite">
                    Showing {{startIndex}} to {{endIndex}} of {{totalItems}} entries</div>
                <nav class="page">
                    <!-- <ngb-pagination class="pagination" [collectionSize]="totalItems" [(page)]="page" [maxSize]="5" [pageSize]="10"
                (pageChange)="setPage($event)" aria-label="Default pagination">
                <ng-template ngbPaginationPrevious>Prev</ng-template>
                <ng-template ngbPaginationNext>Next</ng-template>
              </ngb-pagination> -->

                    <pagination class="pagination brd-0" [rotate]="true" [totalItems]="totalItems"
                        [(ngModel)]="currentIndex" (pageChanged)="setPage($event)" previousText="Prev" nextText="Next"
                        [maxSize]="5" [itemsPerPage]="pageSize.value" aria-label="Default pagination" [boundaryLinks]="true" [directionLinks]="true">

                    </pagination>

                </nav>
            </div>
        </div>
        <!-- <div class="col-md-12 text-center text-info" *ngIf="data.length === 0 && !isLoadingResults">
            <h6>
                <span class="tim-note">No Records.</span>
            </h6>
        </div> -->
    </div>
</div>